import { tsIoValidate } from "../../../../utils/general/generalUtils"
import {
    EmbeddedUrlResponse,
    IEmbeddedUrlResponse,
} from "../../types/insights/insightsTypes"

export const insightsMapper = {
    /**
     * Maps the response from the User Suggestion API to the IUsersType interface.
     * @param response - The response from the API.
     * @returns The mapped object of type IUsersType.
     */
    mapEmbeddedUrl: (response: unknown): IEmbeddedUrlResponse => {
        const res = tsIoValidate<IEmbeddedUrlResponse>(
            EmbeddedUrlResponse,
            response,
            "Error mapping quicksight embedded url response."
        )
        return res
    },
}
